import refs from "../refs"
import {showBackdrop, hideBackdrop} from "../utils"

const {thankYouBackdrop, thankYouCloseButton, appointmentBackdrop, feedbackBackdrop} = refs;

const handleSubmit = (event) => {
    if (event && typeof event.preventDefault === "function" && event.type === "submit") {
        event.preventDefault();
    }
    if(!appointmentBackdrop.hasClass('is-hidden')){
        hideBackdrop(appointmentBackdrop);
    }
    if(!feedbackBackdrop.hasClass('is-hidden')){
        hideBackdrop(feedbackBackdrop);
    }
    showBackdrop(thankYouBackdrop);
}

document.addEventListener("wpcf7mailsent", handleSubmit);
document.addEventListener("leadFormsGoSubmitted", handleSubmit);

thankYouCloseButton.on("click", () => hideBackdrop(thankYouBackdrop));

